<template>
  <el-dialog
    class="radish-dia"
    title="请选择项目"
    top="70px"
    width="500px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :style="`z-index:${zIndex}`"
  >
    <el-alert title="可以根据项目名称、项目编号、公司名称进行搜索" type="warning"> </el-alert>
    <div class="radish-dia-search">
      <label>输入并回车搜索项目：</label>
      <el-input v-model="keywords" size="mini" placeholder="请输入内容" @keyup.enter.native="searchPro"></el-input>
    </div>
    <div v-if="showType==='default'">
      <div v-if="advicePros.length>0" :class="[followPros.length>0?'radish-dia-body-small':'','radish-dia-body']">
        <p class="radish-dia-title">最新操作项目</p>
        <div class="checkbox-group-box">
          <el-checkbox-group v-model="advicePids">
            <div v-for="(v, k) in advicePros" :key="k">
              <el-checkbox :label="v.value" style="margin-right:8px"> {{ v.label }} </el-checkbox><el-tag type="primary" size="mini" v-if="v.ifTwoWeek">近两周{{v.type||'新增'}}</el-tag>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <!-- <div v-if="twoWeeksAdvicePros.length>0&&type==='review'" :class="[followPros.length>0?'radish-dia-body-small':'','radish-dia-body']">
        <p class="radish-dia-title">近两周操作项目</p>
        <div class="checkbox-group-box" v-if="type==='review'">
          <el-checkbox-group v-model="advicePids">
            <div v-for="(v, k) in twoWeeksAdvicePros" :key="k">
              <el-checkbox :label="v.value" style="margin-right:8px"> {{ v.label }} </el-checkbox><el-tag type="primary" size="mini" v-if="v.ifTwoWeek">{{v.type||'新增'}}</el-tag>
            </div>
          </el-checkbox-group>
        </div>
      </div> -->
      <div v-if="followPros.length>0" :class="[advicePros.length>0?'radish-dia-body-small':'','radish-dia-body']">
        <p class="radish-dia-title">本周重点关注项目</p>
        <div class="checkbox-group-box">
          <el-checkbox-group v-model="followPids">
            <div v-for="(v, k) in followPros" :key="k">
              <el-checkbox :label="v.value"> {{ v.label }} </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div v-else class="radish-dia-body">
      <p class="radish-dia-title">搜索结果<i class="el-icon-back" @click="showType='default'"></i></p>
      <div v-if="showPros.length>0" class="checkbox-group-box">
        <el-checkbox-group v-model="pids">
          <div v-for="(v, k) in showPros" :key="k">
            <el-checkbox :label="v.value"> {{ v.label }} </el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <p v-else>没有筛选出项目，请修改关键词</p>
      <el-pagination
        layout="pager"
        :hide-on-single-page="true"
        :page-size="pageSize"
        :current-page="page"
        :total="total"
        @current-change="pageChange">
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
const dateFormat = require('dateformat')
export default {
  data: function() {
    return {
      dialogVisible: false,
      keywords: '',
      searchKeywords: '',
      page:1,
      pageSize: 10,
      proAll: [],
      proOptions: [],
      pids: [],
      rows: null,
      type: '',
      zIndex: 1003,
      isPending: false,
      showType: 'default',
      advicePids:[],
      followPids:[],
      advicePros:[],
      followPros:[],
      rowIndex: 0,
    }
  },
  computed: {
    filterPros(){
      const { searchKeywords, proAll } = this
      const arr = proAll.filter(item => `${item.num}` === searchKeywords)

      if (arr.length === 0) {
        const kwArr = searchKeywords.split(' ').filter(a=>a)
        if (kwArr.length > 1) {
          return proAll.filter(item => {
            const flagArr = []
            for(let index = 0,leng = kwArr.length;index < leng; index += 1){
              flagArr.push(
                item.客户公司.includes(kwArr[index]) || item.项目名称.includes(kwArr[index]) || item.num.includes(kwArr[index])
              )
            }
            const trueFlagArr = flagArr.filter(a=>a)
            return flagArr.length === trueFlagArr.length
          })
        } else return proAll.filter(item => item.label.includes(searchKeywords))
      } else return arr
    },
    showPros(){
      const { filterPros, page, pageSize } = this
      return filterPros.slice((page-1)*pageSize,page*pageSize)
    },
    total(){
      return this.filterPros.length
    },
    // twoWeeksAdvicePros(){
    //   const twoWeeksAdvicePros=this.advicePros.filter(a=>a.最新操作时间>Date.now()-1000*60*60*24*14)
    //   console.log(this.advicePros);
    //   console.log(twoWeeksAdvicePros);
    //   twoWeeksAdvicePros.forEach(t=>t.type=t.近期操作.slice(0,2))
    //   return twoWeeksAdvicePros
    // },
  },
  methods: {
    pageChange(page){
      this.page = page
    },
    setConfirmFunc(onConfirm){
      this.onConfirm = onConfirm
    },
    formatName(account) {
      const user = app.users.find(u => u.account === account)
      return user ? `${user.姓名}${user.account}`: account
    },
    async show(rows, type, onConfirm) {
      if (rows.length == 0) {
        return this.$alert('请勾选人选', { showClose: false })
      }
      this.rowIndex = 0
      if (type === 'recommend') {
        this.doWarning(rows, type, onConfirm)
      } else {
        this.doShow(rows, type, onConfirm)
      }
    },
    async doWarning(rows, type, onConfirm) {
      let recentStatus = []
      const res = await app.service('radish').getRadishRecentStatus({ rid: rows[this.rowIndex]._id })
      if (res && res.status === 'success') {
        recentStatus = res.data.filter(rs => rs.顾问 !== account)
      }
      const account = app.user.account
      if (recentStatus && recentStatus.length > 0) {
        const msg = recentStatus.reduce(
          (str, rs) => str + `人选${rs.候选人}已于${dateFormat(rs.确认时间 || rs.createdAt, 'yyyy年mm月dd日')}进入 ${rs.客户公司}-${rs.项目名称} 项目的${rs.类型}，推荐前建议您与推荐顾问 ${this.formatName(rs.顾问)} 就人选最新状态进行沟通。`,          ''
        )
        this.$confirm(msg, '提示', {
          confirmButtonText: '忽略继续推荐',
          cancelButtonText: '取消推荐',
          type: 'warning'
        }).then(async () => {
          const ac = recentStatus.map(rs => rs.顾问).filter(rs => rs)
          const msg2 = `为了避免冲突，在您完成推荐动作之后，系统将会通知 ${ac.map(a=>this.formatName(a)).join('、')}。是否确认继续推荐。`
          this.$confirm(msg2, '提示', {
            confirmButtonText: '确认推荐',
            cancelButtonText: '取消推荐',
            type: 'warning'
          }).then(async () => {
            // 通知相关顾问
            for (let i = 0; i < recentStatus.length; i++) {
              const item = recentStatus[i]
              const notify = {
                title: `您最近${item.类型}的人选${item.候选人}被推荐`,
                type: '人选',
                action: '被人推荐',
                content: `您最近【${item.类型}】的人选【${item.候选人}】被顾问【${this.formatName(account)}】推荐了`,
                rid: item.rid,
              }
              await app.service('notify').addNotify({
                notify,
                to: ac,
              })
            }
            if (this.rowIndex < rows.length - 1) {
              this.rowIndex ++
              this.doWarning(rows, type, onConfirm)
            } else {
              this.doShow(rows, type, onConfirm)
            }
          }).catch(() => {
            rows.splice(this.rowIndex, 1)
            if (this.rowIndex < rows.length - 1) {
              this.doWarning(rows, type, onConfirm)
            } else {
              this.doShow(rows, type, onConfirm)
            }
          })
        }).catch(() => {
          rows.splice(this.rowIndex, 1)
          if (this.rowIndex < rows.length - 1) {
            this.doWarning(rows, type, onConfirm)
          } else {
            this.doShow(rows, type, onConfirm)
          }
        })
      } else {
        if (this.rowIndex < rows.length - 1) {
          this.doWarning(rows, type, onConfirm)
        } else {
          this.doShow(rows, type, onConfirm)
        }
      }
    },
    async doShow(rows, type, onConfirm) {
      if (rows.length == 0) {
        return false
      }
      console.info('测试')
      this.showType = 'default'
      const rowsArr = rows || []
      const setRows = []
      rowsArr.forEach(val=>{
        const has = setRows.find(a=>a._id===val._id)
        if(!has) setRows.push(val)
      })
      this.rows = setRows
      this.type = type
      this.zIndex = app.root.dragindex++
      this.dialogVisible = true
      if(!this.$route.path.includes('/project20/')) this.onConfirm = onConfirm
      await Promise.all([this.getAdvicePros(),this.getFollowPro()])
      if(this.advicePros.length===0&&this.followPros.length===0) this.showType = 'search'
      this.loadAllPros()
    },
    async getAdvicePros(){
      const account = app.user.account === 'wpgao' ? 'AkiWu' : app.user.account
      const res = await app.service('project').getAdviserProject({
        account: account,
        limit: 10000,
        page: 1,
        query: {keywords: "", 行业: [], 职能模块: [], 项目阶段: []},
        sortType: "人选最新动态",
        dataType: 'simple',
      })
      const advicePros = res.status === 'success'? res.data : []
      this.advicePros = advicePros.map(item => {
        const label = `${item['客户公司']}${item['部门']?`-${item['部门']}`:''}${item['项目名称']?`-${item['项目名称']}`:''}`
        const ifTwoWeek=(this.type==='review'||this.type==='interview')&&(item.最新操作时间>Date.now()-1000*60*60*24*14||(!item.近期操作&&item.createdAt>Date.now()-1000*60*60*24*14))
        return { label: label, value: item._id, num: item.编号, 客户公司: item.客户公司, 项目名称: item.项目名称, 最新操作时间:item.最新操作时间,ifTwoWeek,type:item.近期操作.slice(0,2)==='of'?'offer':item.近期操作.slice(0,2)}
      })
      if(this.type==='interview'){
        this.advicePros=this.advicePros.filter(a=>a.ifTwoWeek&&a.type==='面试')
      }
    },
    async getFollowPro(){
      const res = await app.service('project').list({
        isPined: true,
        limit: 10000,
        page: 1,
        query: {},
        sort: {createdAt: -1},
        dataType: 'simple',
      })
      const followPros = res.status === 'success'? res.data : []
      followPros.sort((a,b)=>b.关注时间 - a.关注时间)
      this.followPros = followPros.map(item => {
        const label = `${item['客户公司']}${item['部门']?`-${item['部门']}`:''}${item['项目名称']?`-${item['项目名称']}`:''}`
        return { label: label, value: item._id, num: item.编号, 客户公司: item.客户公司, 项目名称: item.项目名称 }
      })
    },
    async loadAllPros(){
      let proData=[]
      if(this.type==='review'||this.type==='interview'){
        const pros = await app.service('project').simpleProjects({showAll:false})
        proData = pros.data
      }else{
        await app.getProjects()
        proData = app.projects
      }
      if (proData && proData.length) {
        const arr = proData.map(item => {
          const label = `${item['客户公司']}${item['部门']?`-${item['部门']}`:''}${item['项目名称']?`-${item['项目名称']}`:''}`
          return { label: label, value: item._id, num: item.编号, 客户公司: item.客户公司, 项目名称: item.项目名称 }
        })
        this.proAll = arr
        this.proOptions = arr
      }
      // if (!this.followPro) await this.getFollowPro()
      // const oneMonthAgo = new Date().getTime - 2592000000
      // this.proAll = this.proOptions = (this.followPro || []).concat(this.unFollowPro || []).map(item => {
      //   const label = `${item['客户公司']}-${item['部门']}-${item['项目名称']}${
      //     item.stickie || item.stickie == 0 ? '(本周重点关注项目)' : ''
      //   }`
      //   return { label: label, value: item._id, num: item.编号 }
      // })
    },
    // loadPro: async function() {
    //   if (!app.projects) {
    //     await app.getProjects()
    //   }

    //   // const proData = app.projects
    //   // if (proData && proData.length) {
    //   //   this.proAll = this.proOptions = proData.map(item => {
    //   //     let label = item['项目名称'] + '(' + item['客户公司'] + ')'
    //   //     return { label: label, value: item._id }
    //   //   })
    //   // }
    //   if (!this.followPro) await this.getFollowPro()
    //   // const oneMonthAgo = new Date().getTime - 2592000000
    //   this.proAll = this.proOptions = (this.followPro || []).concat(this.unFollowPro || []).map(item => {
    //     const label = `${item['客户公司']}-${item['部门']}-${item['项目名称']}${
    //       item.stickie || item.stickie == 0 ? '(本周重点关注项目)' : ''
    //     }`
    //     return { label: label, value: item._id, num: item.编号 }
    //   })
    // },
    // async getFollowPro() {
    //   const res = await app.service('company').getDesktopProject({ account: app.user.account })
    //   if (res.status === 'success') {
    //     const list = res.data.map(val => {
    //       val.stickie = val.stickie || 0
    //       return val
    //     })
    //     list.sort((a, b) => b.stickie - a.stickie)
    //     this.followPro = list
    //     const followIds = list.map(val => val._id)
    //     this.unFollowPro = app.projects.filter(val => !followIds.includes(val._id))
    //   } else this.$message.error(res.msg)
    // },
    searchPro() {
      this.showType = 'search'
      if (this.keywords) {
        this.searchKeywords = this.keywords
        this.pageChange(1)
      } else {
        this.showType = 'default'
        this.proOptions = this.proAll
      }
      this.keywords = ''
    },
    // searchPro() {
    //   this.showType = 'search'
    //   if (this.keywords) {
    //     const arr = this.proAll.filter(item => `${item.num}` === this.keywords)
    //     console.log(this.proAll);
    //     if (arr.length === 0) {
    //       const kw_arr = this.keywords.split(' ')
    //       if (kw_arr.length > 1) {
    //         this.proOptions = this.proAll.filter(item => {
    //           return item.客户公司.indexOf(kw_arr[0]) !== -1 && item.项目名称.indexOf(kw_arr[1]) !== -1
    //         })
    //       } else {
    //         this.proOptions = this.proAll.filter(item => item.label.includes(this.keywords))
    //       }
    //     } else {
    //       this.proOptions = arr
    //     }
    //   } else {
    //     this.showType = 'default'
    //     this.proOptions = this.proAll
    //   }
    //   this.keywords = ''
    // },
    async handleConfirm() {
      const ids = []
      if(this.showType==='default'){
        ids.push(...this.advicePids,...this.followPids)
      }else{
        ids.push(...this.pids)
      }
      const resultIds = [...new Set(ids)]

      if (this.type == 'intoProject') {
        if (this.isPending) {
          this.$message.error(`前一次操作未完成，请勿重复操作`)
          return
        }
        this.isPending = true
        await this.intoProject(resultIds)
        this.isPending = false
      } else if (this.type == 'recommend') {
        await this.recommend(resultIds)
      }else if(this.type==='review'||this.type==='interview'){
        this.onConfirm && this.onConfirm(resultIds)
      }
      if(this.showType==='default'){
        this.advicePids = []
        this.followPids = []
      }else{
        this.pids = []
      }

    },
    intoProject: async function(pids) {
      const dt = []
      pids.forEach(pid => {
        this.rows.forEach(row => {
          dt.push({ rid: row._id, pid: pid })
        })
      })
      // console.log(dt)
      const res = await app.service('radish').intoProject(dt)
      if (res.status == 'success') {
        this.$alert('加入成功', {
          showClose: false,
          callback: action => {
            this.onConfirm && this.onConfirm(pids)
          }
        })
      } else {
        this.$alert(res.msg)
      }
      this.dialogVisible = false
    },
    recommend: async function(pids) {
      const recommended = {}
      let successfulRecommend = 0
      const hasNotTel = {}
      for (const pid of pids) {
        const names = []
        const hasNotTelNames = []
        for (const row of this.rows) {
          const res = await app.service('radish').addRecommend({ rid: row._id, pid: pid })
          if (res.status == 'fail') {
            if (res.msg == '已推荐过') {
              names.push(row['姓名'])
            } else if(res.msg == '该人选没有手机号，无法被推荐'){
              hasNotTelNames.push(row['姓名'])
            } else {
              console.log(res.msg)
            }
          } else {
            successfulRecommend += 1
            await app.service('radish').initRecommendText({ rid: row._id, pid: pid })
          }
        }
        if (names.length > 0) {
          recommended[pid] = names
        }
        if (hasNotTelNames.length > 0) {
          hasNotTel[pid] = hasNotTelNames
        }
      }
      // console.log(recommended)
      const recPids = Object.keys(recommended)
      const hasNotTelPids = Object.keys(hasNotTel)
      if (recPids.length > 0) {
        const recedPro = this.proAll.filter(pro => recPids.includes(pro.value))
        let message = '已推荐过'
        recedPro.forEach(pro => {
          const names = recommended[pro.value]
          const nameStr = names.join('、')
          message = `${message}[${nameStr}]到[${pro.label}]`
        })
        this.$alert(message)
      } else if (hasNotTelPids.length > 0) {
        const recedPro = this.proAll.filter(pro => hasNotTelPids.includes(pro.value))
        let message = ''
        recedPro.forEach(pro => {
          const names = hasNotTel[pro.value]
          const nameStr = names.join('、')
          message = `${message}[${nameStr}]没有手机号，无法推荐到[${pro.label}]`
        })
        this.$alert(message)
      } else if(successfulRecommend){
        this.$alert('推荐成功', {
          showClose: false,
          callback: action => {
            this.onConfirm && this.onConfirm(pids)
          }
        })

      }
      this.dialogVisible = false
    },
  },
}
</script>
<style>
.radish-dia > .el-dialog > .el-dialog__body {
  padding: 0 20px;
}
.radish-dia-search {
  padding: 5px 0;
}
.radish-dia-body {
  max-height: 60vh;
  overflow-y: auto;
}
.radish-dia-body-small{
  max-height: 30vh;
  overflow-y: auto;
}
.radish-dia-body,
.radish-dia-body-small{
  display: flex;
  flex-direction: column;
}
.radish-dia-title{
  flex:none;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
}
.radish-dia-title i{
  color: #409EFF;
  font-weight: bold;
  margin-right: 20px;
  cursor: pointer;
}
.checkbox-group-box{
  flex:auto;
  overflow: auto;
}

.radish-dia-body .checkbox-group-box{
  max-height: 400px;
}
.radish-dia-body-small .checkbox-group-box{
  max-height: 200px;
}
</style>
